var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useReducer, useContext } from 'react';
var overlayReducer = function (state, action) {
    var _a;
    var type = action.type, payload = action.payload;
    switch (type) {
        case 'open': {
            return __assign(__assign({}, state), (_a = {}, _a[payload.name] = true, _a));
        }
        case 'close': {
            var newState = __assign({}, state);
            delete newState[payload.name];
            return newState;
        }
        default:
            return state;
    }
};
/** 初始状态 */
var initialState = {};
/** Overlay 状态上下文 */
var OverlayStateContext = createContext(null);
/**
 * 获取 Overlay 状态
 *
 * *React Hook*
 */
export var useOverlayState = function () { return useContext(OverlayStateContext); };
export function OverlayStateProvider(_a) {
    var children = _a.children;
    return (React.createElement(OverlayStateContext.Provider, { value: useReducer(overlayReducer, initialState) }, children));
}
